module.exports = __webpack_public_path__ + "static/media/53.9d7cd794.png";